export const Products = [
  {
    id: 1,
    judul:
      "Kursi Bekas Lalisa Blackpink (Beban maksimal: 30 Ton, Made in: Purwodadi, Chile Republic)",
    harga: 1850000,
    rating: 4,
    gambar:
      "https://id-test-11.slatic.net/p/0f5e2f7d0cdb662d5b821cfa7c176bf4.jpg",
  },
  {
    id: 2,
    judul:
      "Makanan Kpopers: Bubur Sisa Kim Jong Un (Hanya produksi 1 porsi / minggu live dari Korea Utara)",
    harga: 50000,
    rating: 5,
    gambar:
      "https://asset-a.grid.id/crop/0x0:0x0/x/photo/2021/07/01/resep-bubur-ayam-kuning-kreasi-20210701052051.jpg",
  },
  {
    id: 3,
    judul:
      "Buku Wajib Anak Kos (Memasak nasi goreng tanpa nasi (makan penggorengannya))",
    harga: 3000,
    rating: 5,
    gambar:
      "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1479534607i/33011516.jpg",
  },
  {
    id: 4,
    judul: "Ganjal Mobil: Parkir Mobil dengan Aman mulai dari 20ribuan",
    harga: 23000,
    rating: 5,
    gambar: "https://s4.bukalapak.com/img/44056410292/s-300-300/data.jpeg",
  },
  {
    id: 5,
    judul: "Sepeda penambah masa otot",
    harga: 323000,
    rating: 2,
    gambar:
      "https://i.pinimg.com/474x/a1/e3/51/a1e3517178ba61e0b08baf0bce2295cd.jpg",
  },
  {
    id: 6,
    judul: "Tiang Jemuran",
    harga: 200000,
    rating: 3,
    gambar:
      "https://awsimages.detik.net.id/community/media/visual/2018/02/15/1526f77f-7c34-4104-b78c-6825c4d3cd77_169.jpeg",
  },
];
